import mitt from 'mitt';

export enum EventBusEvents {
  JobsUpdated = 'jobsUpdated',
}

export type JobEvents = {
  jobsUpdated: void;
};

export const jobEventBus = mitt<JobEvents>();
